module.exports = __webpack_public_path__ + "static/img/7.7d942e6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/4/sp/7.png
// module id = JHe5
// module chunks = 0